import ToastContainer from 'react-bootstrap/ToastContainer';

import Growl from '@/App/Growl/Growl';
import { getAllGrowls } from '@/store/growl/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const GrowlList = () => {
  const allGrowls = useAppSelector(getAllGrowls);

  return (
    <ToastContainer
      className="position-fixed p-32px pt-128px vh-100 overflow-y-auto"
      position="top-end"
      data-e2e="growl-list"
    >
      {allGrowls.map(({ id: growlId, ...growlItem }) => (
        <Growl key={growlId} growlId={growlId} growlItem={growlItem} />
      ))}
    </ToastContainer>
  );
};
